"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_utils_1 = require("prosemirror-utils");

var isNodeActive = function isNodeActive(type) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (state) {
    if (!type) {
      return false;
    }

    var node = prosemirror_utils_1.findSelectedNodeOfType(type)(state.selection) || prosemirror_utils_1.findParentNode(function (node) {
      return node.type === type;
    })(state.selection);

    if (!Object.keys(attrs).length || !node) {
      return !!node;
    }

    return node.node.hasMarkup(type, Object.assign(Object.assign({}, node.node.attrs), attrs));
  };
};

exports.default = isNodeActive;